var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMyProperty = function SvgMyProperty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.38,
    d: "M6.035 8.022v-2.98A1.986 1.986 0 0 1 8.02 3.058h9.93a1.986 1.986 0 0 1 1.986 1.986v11.916a1.986 1.986 0 0 1-1.986 1.986h-5.958m0 0v-6.129c0-.526-.21-1.031-.582-1.404L8.432 8.433a1.986 1.986 0 0 0-2.808 0l-2.98 2.98a1.99 1.99 0 0 0-.582 1.403v4.143a1.986 1.986 0 0 0 1.987 1.986h2.979m4.965 0H7.028m0 0v-3.972"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.964 7.03zm-3.972 0zm3.972 3.972zm0 3.972z"
  })));
};
export default SvgMyProperty;